/* eslint-disable import/prefer-default-export */
const getEnv = (k) => window._env_?.[k] ?? process.env[k];

export async function sendBenefitAgentMessage({ message, token, agentConfigName, threadId }) {
  if (!agentConfigName?.agent_name) {
    throw new Error('agentConfigName.agent_name is required');
  }

  window.dispatchEvent(new Event('api-activity'));
  const url = `${getEnv('REACT_APP_AGENTIC_API_BASE_URL')}/api/dob/chat`;
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Accept: '*/*',
      'Content-Type': 'application/json',
      Authorization: token ? `Bearer ${token}` : undefined,
      'x-functions-key': getEnv('REACT_APP_AGENTIC_API_FUNCTION_KEY'),
    },
    body: JSON.stringify({
      message,
      ...(threadId && { thread_id: threadId }),
    }),
  });

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(
      errorText || 'Something went wrong while contacting the Benefit Agent. Try again shortly.',
    );
  }

  return response.json();
}
